import { render, staticRenderFns } from "./mandala-lags-display.component.vue?vue&type=template&id=368b0009&scoped=true&"
import script from "./mandala-lags-display.component.vue?vue&type=script&lang=ts&"
export * from "./mandala-lags-display.component.vue?vue&type=script&lang=ts&"
import style0 from "./mandala-lags-display.component.vue?vue&type=style&index=0&id=368b0009&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "368b0009",
  null
  
)

export default component.exports